
function parentElement(el, selector) {
    // Get the parent element of an element that matches a selector
    const parentEl = el.parentElement;
    if (!parentEl) return null;
    if (!selector) return parentEl;
    if (parentEl.matches(selector)) return parentEl;
    return parentElement(parentEl, selector);
}

function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

const roundToNthDecimal = (num, n) => {
    const formattedNumber = new Intl.NumberFormat('en', { minimumFractionDigits: n, maximumFractionDigits: n }).format(num);
    const formattedNumberInNumber = parseFloat(formattedNumber);
    return formattedNumberInNumber;
};

window.parentElement = parentElement;
window.debounce = debounce;
window.roundToNthDecimal = roundToNthDecimal;
